// ────────────────────────────────────────────────────────────────
// core/guards/auth.guard.ts — gate the authenticated shell (§6.1)
// Unauthenticated visitors are bounced to sign-in with a returnUrl so
// they land back where they aimed after signing in.
// ────────────────────────────────────────────────────────────────

import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { SessionStore } from '../auth/session.store';

export const authGuard: CanActivateFn = (_route, state) => {
  const session = inject(SessionStore);
  const router = inject(Router);

  if (session.isAuthenticated()) return true;

  return router.createUrlTree(['/sign-in'], {
    queryParams: { returnUrl: state.url },
  });
};
